export function setMateriales(state, materiales) {
    state.materiales = materiales
}




export function actListMateriales(state, material) {
    if (material !== null) {
        const index = state.materiales.findIndex(r => r.id === material.id)
        if (index != -1) {
            state.materiales.splice(index, 1, material)   
        }
    }
  
}

export function actDeleteListMateriales(state, id) {
   
    if (id != null) {
        const index = state.materiales.findIndex(r => r.id === id)
        if (index != -1) {
            state.materiales.splice(index, 1)
        }
    }
}



export function setMaterialSelec(state, material) {
    state.materialSelec = material
}




